// Registers the service worker (production builds only) and shows a small
// "new version available" banner when an updated worker takes control.
// The page is never reloaded automatically, so in-progress forms are not lost.

const UPDATE_CHECK_INTERVAL = 60 * 60 * 1000; // 1 hour
// Kept in a variable: Parcel 1 tries to bundle string literals passed to
// navigator.serviceWorker.register(). sw.js is generated by script/pwa/build-pwa.js.
const SW_URL = '/sw.js';

function showUpdateBanner() {
  if (document.getElementById('pwa-update-banner')) return;

  const banner = document.createElement('div');
  banner.id = 'pwa-update-banner';
  banner.setAttribute('role', 'status');
  banner.style.cssText = [
    'position:fixed', 'left:16px', 'right:16px', 'bottom:16px', 'z-index:2147483647',
    'max-width:420px', 'margin:0 auto', 'display:flex', 'align-items:center', 'gap:12px',
    'padding:12px 16px', 'border-radius:8px', 'background:#222', 'color:#fff',
    'box-shadow:0 4px 16px rgba(0,0,0,.3)', 'font-size:14px',
    'padding-bottom:calc(12px + env(safe-area-inset-bottom))'
  ].join(';');

  const text = document.createElement('span');
  text.textContent = 'New version available';
  text.style.flex = '1';

  const reload = document.createElement('button');
  reload.type = 'button';
  reload.textContent = 'Reload';
  reload.style.cssText = 'border:0;border-radius:4px;padding:6px 12px;background:#fff;color:#222;font-weight:600;cursor:pointer';
  reload.onclick = () => window.location.reload();

  const dismiss = document.createElement('button');
  dismiss.type = 'button';
  dismiss.setAttribute('aria-label', 'Dismiss');
  dismiss.textContent = '×';
  dismiss.style.cssText = 'border:0;background:transparent;color:#fff;font-size:20px;line-height:1;cursor:pointer';
  dismiss.onclick = () => banner.remove();

  banner.append(text, reload, dismiss);
  document.body.appendChild(banner);
}

export default function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    // Only prompt when replacing an existing worker, not on first install.
    const hadController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hadController) showUpdateBanner();
    });

    navigator.serviceWorker
      .register(SW_URL, { scope: '/' })
      .then(registration => {
        const checkForUpdate = () => registration.update().catch(() => {});
        setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdate();
        });
      })
      .catch(err => console.warn('Service worker registration failed:', err));
  });
}
